/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Quantity_Sr_LabelInputs */

const vi_report_inventory_quantity_sr_label = /** @type {(inputs: Report_Inventory_Quantity_Sr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tồn:`)
};

/**

* @param {Report_Inventory_Quantity_Sr_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_quantity_sr_label = /** @type {((inputs?: Report_Inventory_Quantity_Sr_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Quantity_Sr_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_quantity_sr_label(inputs)
});